import publicRoutes from './publicRoutes'
import privateRoutes from './privateRoutes'

const routes = [...publicRoutes, ...privateRoutes]

export const customRouter = {
  goTo (routeName, queryString) {
    const qs = queryString || ''
    if (typeof routeName === 'string') {
      window.location.href = routeName + qs
    } else if (typeof routeName === 'object' && routeName.name) {
      const matchedRoute = routes.filter(route => route.name === routeName.name)
      if (matchedRoute.length && matchedRoute[0].path) {
        window.location.href = matchedRoute[0].path + qs
      } else {
        process.env.NODE_ENV !== 'production' && console.log('%cCustomRouter: This route does not exist in list of routes', 'padding: 5px 10px; border-radius: 4px; background: #f58220; color: #fff;')
      }
    } else {
      throw new Error('Unrecognized command in custom router')
    }
  },
  isPublicRoute () {
    let href = window.location.pathname
    if (href.endsWith('/')) href = href.slice(0, -1)

    const matchPublicRoute = routes.filter(route => {
      return route.path.indexOf(href) > -1 && route.public
    })

    if (matchPublicRoute.length) {
      return matchPublicRoute[matchPublicRoute.length - 1].public
    }

    return false
  },
  getRouteByName (routeName) {
    if (typeof routeName === 'object' && routeName.name) {
      const matchedRoute = routes.filter(route => route.name === routeName.name)
      if (matchedRoute.length && matchedRoute[0].path) {
        return matchedRoute[0].path
      } else {
        process.env.NODE_ENV !== 'production' && console.log('%cCustomRouter: This route does not exist in list of routes', 'padding: 5px 10px; border-radius: 4px; background: #f58220; color: #fff;')
      }
    } else {
      throw new Error('Unrecognized command in custom router, use { name: \'route-name\' }')
    }
  },
  getCurrentRoute () {
    let href = window.location.pathname
    if (href.endsWith('/')) href = href.slice(0, -1)

    if (href.indexOf('/') > -1) {
      return href.split('/')[1]
    }
    return ''
  }
}
